'use client';

import type { ReactNode } from 'react';
import { StorefrontCartProvider } from '@/lib/storefront-cart-context';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <StorefrontCartProvider>
      {children}
    </StorefrontCartProvider>
  );
}
